export default __webpack_public_path__ + "static/media/ln-white.454ce6d9.svg";